import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * UnlockCard — rendered when a feature returns `{ unlock_hint }`.
 * It's a discover-the-feature card, never a paywall.
 *
 * Props:
 *   hint:    the `unlock_hint` blob from the backend
 *   onClose: optional close handler
 */
export default function UnlockCard({ hint, onClose }) {
  const navigate = useNavigate();
  if (!hint) return null;

  return (
    <div
      className="rounded-2xl p-5 my-3"
      style={{
        background: 'linear-gradient(135deg, rgba(0,201,167,0.08), rgba(0,217,255,0.06))',
        border: '1px solid rgba(0,201,167,0.3)',
      }}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <div className="text-[10px] uppercase tracking-widest font-bold opacity-70 mb-1">
            ⚡ Unlock more
          </div>
          <div className="font-bold">{hint.message}</div>
        </div>
        {onClose && (
          <button onClick={onClose} className="opacity-50 hover:opacity-100">✕</button>
        )}
      </div>
      <div className="grid sm:grid-cols-3 gap-2">
        {(hint.options || []).map((opt, i) => (
          <button
            key={i}
            onClick={() => navigate('/pricing')}
            className="text-left rounded-xl p-3 transition-all hover:-translate-y-0.5"
            style={{
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(0,201,167,0.25)',
            }}
          >
            {opt.type === 'pack' ? (
              <>
                <div className="font-bold">{opt.credits} credits</div>
                <div className="text-xs opacity-70 mb-1">${(opt.price_cents/100).toFixed(2)} once</div>
                {opt.bonus && (
                  <div className="text-[10px] uppercase tracking-widest font-bold"
                       style={{ color: '#00C9A7' }}>{opt.bonus}</div>
                )}
              </>
            ) : (
              <>
                <div className="font-bold">{opt.tier === 'athlete_pro' ? 'Athlete Pro' : 'Family Pro'}</div>
                <div className="text-xs opacity-70 mb-1">
                  ${(opt.price_cents/100).toFixed(2)}/mo · {opt.credits} credits
                </div>
                <div className="text-[10px] uppercase tracking-widest font-bold"
                     style={{ color: '#00D9FF' }}>Subscribe</div>
              </>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
